import { environment } from "../../../environments/environment";

export class AppConfig {
  // Define all the constants of the app

  public static SSN_SYSTEM = [
    "urn:oid:2.16.840.1.113883.4.1",
    "http://hl7.org/fhir/sid/us-ssn",
  ];

  public static RACE_DEFINITION =
    "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race";

  public static RACE_OMB_SYSTEM = [
    "http://hl7.org/fhir/us/core/ValueSet/omb-race-category",
    "urn:oid:2.16.840.1.113883.6.238",
    "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
  ];

  public static RACE_OMB_CODES = [
     "1002-5","2028-9","2054-5","2076-8","2106-3","ASKU","UNK",
  ];

  // TODO Adjust Mapping  for Race_details System value Mappings
  //public static racedetails_ombsystem = [
  //   "http://hl7.org/fhir/us/core/ValueSet/detailed-race",
  //   "urn:oid:2.16.840.1.113883.6.238",
  //   "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
  // ];

  public static ETHINCITY_DEFINITION =
    "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity";

  public static ETHNICITY_OMBSYSTEM = [
    "http://hl7.org/fhir/us/core/ValueSet/omb-ethnicity-category",
    "urn:oid:2.16.840.1.113883.6.238",
  ];

  public static GENDER =
    "http://hl7.org/fhir/us/core/StructureDefinition/us-core-birthsex";

  //CIBMTR Namespaces
  public static CIBMTR_CRID_NAMESPACE = "http://cibmtr.org/identifier/CRID";
  public static CIBMTR_CENTERS_NAMESPACE =
    "http://cibmtr.org/codesystem/transplant-center";

  public static RXNORM_SYSTEM = "http://www.nlm.nih.gov/research/umls/rxnorm";

  //FHIR Logical ID for Absolute URI
  public static FHIR_LOGICALID_NAMESPACE = "urn:ietf:rfc:3986";

  //resource
  public static RESOURCE_TYPE = [
    "Observation",
    "MedicationRequest",
    "Medication",
  ];

//EHR Redirect URL
public static EHR_OAUTH_REDIRECT_URL = environment.ehr_redirect_url;
public static EHR_CLIENT_ID = environment.ehr_client_id;


//Fhir Backend (a.k.a Middleware) URLs
public static CRID_SERVICE_ENDPOINT = environment.cibmtr_fhir_r4_url + "Patient/$crid-assignment";

public static CIBMTR_FHIR_R3_URL = environment.cibmtr_fhir_r3_url;

public static CIBMTR_FHIR_R4_URL = environment.cibmtr_fhir_r4_url;



  public static LOINC_SYSTEM = "http://loinc.org";

  public static LAB_LOINC_CODES = environment.lab_loinc_codes;

  public static VS_LOINC_CODES = environment.vs_loinc_codes;

  public static LOGICAL_CLIENT_IDS = environment.logica_client_ids
    .toString()
    .split(",");

  public static LOGICA_EHRS = environment.logica_ehrs.toString().split(",");

  public static DATE_RANGE_COMMON_MESSAGE = "Date range selected is greater than 2 years. Data retrieval may take longer than expected. Do you want to continue?";
  public static DATE_RANGE_MESSAGE_ALL_LABS = "Retrieval of All Labs will use the date range specified. If there is no date range specified the default date range is the last two years. Do you want to continue?";
  public static DATE_RANGE_MESSAGE_VITALS = "Retrieval of Vital Signs will use the date range specified. If there is no date range specified the default date range is the last two years. Do you want to continue?";
  public static DATE_RANGE_MESSAGE_PRIO_LABS = "Retrieval of Priority Labs will use the date range specified. If there is no date range specified the default date range is the last two years. Do you want to continue?";

  public static CRA_APP_VERSION = environment.cra_version;
  public static MS_APP_VERSION = environment.ms_version;
  public static PI_API_URL = environment.pi_api_url;
  public static ENABLE_MSPI_ORG_LOOKUP = environment.enableMspiOrgLookup === "true";
  public static ENABLE_EULA = environment.enableEula === "true";
}
